module.exports = __webpack_public_path__ + "static/media/clock still 03.0341540d.webp";